/**
 * 3 Cards section – scroll-driven animation (Figma: 3034:50, 3034:36).
 *
 * Each card: one continuous motion from start (below, invisible) to end
 * (final composed position with rotation). Ease-out cubic drives
 * ALL properties (opacity, translateX, translateY, rotate) at the same rate.
 * Stagger only shifts when each card begins — the motion itself is identical.
 *
 * Full animation within ~55vh of scroll.
 */

(function() {
  var START_Y = 100;
  var START_SCALE = 0.88;
  var CARD_STAGGER = [0.00, 0.12, 0.24];
  var CARD_DUR = 0.76;

  var COMPOSE_ROTATE = [-15, 0, 20];
  var COMPOSE_DY = [99, 0, 17];

  function easeOutCubic(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    return 1 - Math.pow(1 - t, 3);
  }

  function clamp01(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  }

  function getProgress(section) {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    var start = vh * 0.85;
    var scrollRange = vh * 0.65;
    return clamp01((start - rect.top) / scrollRange);
  }

  function getComposeDX(inner, wrappers) {
    var innerW = inner.offsetWidth;
    var cardW = wrappers[0].offsetWidth;
    var scale = innerW / 1360;

    var targetLeft = [Math.round(59 * scale), Math.round((innerW - cardW) / 2), Math.round(852 * scale)];
    var dx = [];
    for (var i = 0; i < 3; i++) {
      dx.push(targetLeft[i] - wrappers[i].offsetLeft);
    }
    return dx;
  }

  function update(section) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    var inner = section.querySelector('.cards-3__inner');
    if (!inner) return;
    var wrappers = inner.querySelectorAll('.cards-3__card-wrapper');
    if (wrappers.length < 3) return;

    if (reduceMotion || isDesignMode) {
      for (var k = 0; k < 3; k++) {
        wrappers[k].style.opacity = '1';
        wrappers[k].style.transform = '';
      }
      return;
    }

    var isMobile = window.innerWidth <= 729;
    var progress = getProgress(section);
    var composeDX = isMobile ? null : getComposeDX(inner, wrappers);

    for (var i = 0; i < 3; i++) {
      var t = easeOutCubic(clamp01((progress - CARD_STAGGER[i]) / CARD_DUR));
      var opacity = clamp01(t * 4);

      if (isMobile) {
        var s = START_SCALE + (1 - START_SCALE) * t;
        wrappers[i].style.opacity = String(opacity);
        wrappers[i].style.transform = 'translateY(' + (START_Y * (1 - t)) + 'px) scale(' + s + ')';
        continue;
      }

      var tx = Math.round(composeDX[i] * t);
      var ty = Math.round(START_Y * (1 - t) + COMPOSE_DY[i] * t);
      var rot = Math.round(COMPOSE_ROTATE[i] * t * 10) / 10;
      var s = START_SCALE + (1 - START_SCALE) * t;

      wrappers[i].style.opacity = String(opacity);
      wrappers[i].style.transform =
        'translate(' + tx + 'px, ' + ty + 'px) rotate(' + rot + 'deg) scale(' + s + ')';
    }
  }

  function init(section) {
    if (!section || section.dataset.cards3Init) return;
    section.dataset.cards3Init = '1';

    var ticking = false;
    function onScrollOrResize() {
      if (!ticking) {
        requestAnimationFrame(function() {
          update(section);
          ticking = false;
        });
        ticking = true;
      }
    }

    update(section);
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    section._cards3Cleanup = function() {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      delete section.dataset.cards3Init;
      delete section._cards3Cleanup;
    };
  }

  function run() {
    document.querySelectorAll('.cards-3[data-cards-3]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.detail.querySelector('.cards-3[data-cards-3]');
      if (section) init(section);
    });
    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.detail.querySelector('.cards-3[data-cards-3]');
      if (section && section._cards3Cleanup) section._cards3Cleanup();
    });
  }
})();
